import React, {useCallback, useContext, useEffect, useRef, useState} from "react";
import {Container} from "react-bootstrap";
import {AgGridReact} from "ag-grid-react";
import ActionsRenderer from "components/ActionsRenderer";
import AgGridToolbar from "components/AgGridToolbar/AgGridToolbar";
import PageHeader from "components/PageHeader";
import useWindowDimensions from "hooks/Dimensions";
import {AssetTransferContext} from "./context";
import * as URL from "service/UrlConstant";
import {dateToString, formatDateString, stringToDate, yearMonthDayToPickerDateFormat} from "utils/FormatUtils";
import {SecurityContext} from "context/security";
import {ToastContext} from "context/Toast";
import {ActionPanelContext} from "context/action";
import AuthenticationService from "service/AuthenticationService";
import {UtilsContext} from "context/utils";
import * as Routes from "routes/Routes";
import {useHistory, useLocation} from "react-router-dom";
import {
    cellAlignment,
    cellStyleChecker, cellStyleCheckerStatusError,
    numberFormat3FractionalDigits,
    numberFormat5FractionalDigits,
    numberFormatter
} from "utils/NumberUtils";
import {createExcelExportParams, getFilteredColumns, updateColumnHideState} from "../../utils/ExcelExportUtils";
import {ENABLE_SCROLL_BUTTONS_PAGINATION_SIZE, GRID_COLUMN_PROPERTY} from "../../utils/Constants";
import {EntityAccountsContext} from "../../components/entity-accounts/context";
import {
    addPropertiesToGridColumns,
    getDisplayedNumberOfGridRows,
    getSelectedRows,
    updateGridColumDefs
} from "../../utils/gridColumnUtils";
import {getAllErrorValuesAsString} from "../../utils/ErrorUtils";
import {FilterContext} from "../../layouts/SidePanelLayout";
import ScrollButton from "../../components/AgGridToolbar/ToolBarButtons/ScrollButton";
import {ASSET_TRANSFER_CAPTURE_PANEL_ACTIVITIES_PAGE} from "./context/AssetTransferContext";
import {
    ASSET_TRANSFER_CANCEL_URL,
    ASSET_TRANSFER_DELETE_LIST_URL,
    ASSET_TRANSFER_SAVED_LIST_URL,
    ASSET_TRANSFER_UPDATE_LIST_NAME_URL
} from "service/UrlConstant";
import AssetTransferSearchParamBadge from "./AssetTransferSearchParamBadge";

export default function AssetTransferActivitiesPanel() {
    const {
        hiddenExportGridApi,
        paginationPageSize,
        setPaginationPageSize,
        showButton,
        setShowButton
    } = useContext(UtilsContext);
    const {
        assetTransferCaptureDisplayState,
        setAssetTransferCaptureDisplayState,
        clearAssetTransferSearchAndLoadHome,
        showGridToolbar,
        headerCheckboxChecked,
        setHeaderCheckedboxChecked,
        selectedRows,
        setSelectedRows,
        selectedAnyCheckbox,
        setSelectedAnyCheckbox,
        assetTransferPanelFilterState,
        setShowGridToolbar,
        buildAssetTransferActivitiesSearch,
        gridColumnApi,
        setGridColumnApi,
        columnState,setViewClicked,
        setColumnState, amendClicked, getRowStyle
    } = useContext(AssetTransferContext);
    const {
        makePostRequest,
        makePatchRequestWithParams,
        makeDeleteRequest,
        makeGetRequest
    } = useContext(SecurityContext);
    const {success, error} = useContext(ToastContext);
    const {
        setHandleSaveFunction,
        setHandleDeleteFunction,
        setHandleRenameFunction,
        setHandleExportFunction,
        setSavedSearchName,
        setHandleCancelAssetTransferFunction
    } = useContext(ActionPanelContext);
    const {
        setManagerAndAccountDetails,
        clearEntityAccounts,
        entityAccountsNoSwap,
        paramBadgeInfo,
        getMemoizedEntityAccountsNoSwap
    } = useContext(EntityAccountsContext);
    const {showFilter, setShowFilter} = useContext(FilterContext);

    const [rowData, setRowData] = useState([]);
    const [gridApi, setGridApi] = useState(null);

    const assetTransferActivitiesGrid = useRef(null);

    const [columnDefs, setColumnDefs] = useState([]);
    const {isMobile} = useWindowDimensions();
    const myGrid = useRef(null);
    let history = useHistory();
    let pathname = useLocation().pathname;

    function navigateToPage(path) {
        history.push(path);
    }

    const saveAssetTransferSearch = (savedName, gridApi, onSuccess, onError) => {
        const columnState = gridColumnApi?.getColumnState?.() || [];
        const displayedColumns = gridColumnApi?.getAllDisplayedColumns?.() || [];
        const colIds = displayedColumns?.map(column => column.getColId?.() || "")
        const gridState = {
            columnState,
            colIds
        }
        const onSuccessResponse = (response) => {
            if (onSuccess) onSuccess();
            assetTransferCaptureDisplayState.isSavedTradeList = true;
            assetTransferCaptureDisplayState.savedName = response.data.savedName;
            assetTransferCaptureDisplayState.savedNameListId = response.data.assetTransferListId;
            setAssetTransferCaptureDisplayState(assetTransferCaptureDisplayState);
            setSavedSearchName(savedName);
            success("AssetTransfer activities search successfully saved")
        }

        const onErrorResponse = (err) => {
            console.error(err);
            if (onError) onError(err);
        }

        const savedListToCreate = {
            savedName: savedName,
            cdUser: AuthenticationService.getAuthenticatedUserName(),
            managerId: assetTransferCaptureDisplayState.assetTransferActivitiesSearch.managerId,
            subManagerId: assetTransferCaptureDisplayState.assetTransferActivitiesSearch.subManagerId,
            accountId: assetTransferCaptureDisplayState.assetTransferActivitiesSearch.accountId,
            status: assetTransferCaptureDisplayState.assetTransferActivitiesSearch.status,
            startDate: dateToString(assetTransferCaptureDisplayState.assetTransferActivitiesSearch.startDate),
            endDate: dateToString(assetTransferCaptureDisplayState.assetTransferActivitiesSearch.endDate),
            gridState: JSON.stringify(gridState)
        }

        makePostRequest(savedListToCreate,
            ASSET_TRANSFER_SAVED_LIST_URL, onSuccessResponse, onErrorResponse);
    };

    const updateAssetTransferSearch = (updatedSavedName, gridApi, onSuccess, onError) => {
        const onSuccessResponse = () => {
            if (onSuccess) onSuccess();
            assetTransferCaptureDisplayState.savedName = updatedSavedName;
            setAssetTransferCaptureDisplayState(assetTransferCaptureDisplayState);
            setSavedSearchName(updatedSavedName);
            success("AssetTransfer activities search name successfully updated")
        }

        const onErrorResponse = (err) => {
            console.error(err);
            if (onError) onError(err);
            error("Error occurred with updating assetTransfer activities search name");
        }

        makePatchRequestWithParams(
            ASSET_TRANSFER_UPDATE_LIST_NAME_URL + "/" + assetTransferCaptureDisplayState.savedNameListId, {savedName: updatedSavedName}, onSuccessResponse, onErrorResponse);
    };

    const deleteAssetTransferSearch = (gridApi, onSuccess, onError) => {

        const onSuccessResponse = () => {
            if (onSuccess) onSuccess();
            clearAssetTransferSearchAndLoadHome();
            success('AssetTransfer activities search successfully deleted');
        }

        const onErrorResponse = (err) => {
            console.error(err);
            if (onError) onError(err);
            error('Error occurred with deleting assetTransfer activities search');
        }

        makeDeleteRequest(
            ASSET_TRANSFER_DELETE_LIST_URL + "/" + assetTransferCaptureDisplayState.savedNameListId, onSuccessResponse, onErrorResponse);
    };

    const loadAssetTransferActivitiesForSavedList = (savedAssetTransferListData) => {
        const searchCriteria = {
            savedName: savedAssetTransferListData.savedName,
            managerId: savedAssetTransferListData.assetTransferActivitiesSearch.managerId,
            managerNameShort: savedAssetTransferListData.assetTransferActivitiesSearch.managerName,
            subManagerId: savedAssetTransferListData.assetTransferActivitiesSearch.subManagerId,
            subManagerNameShort: savedAssetTransferListData.assetTransferActivitiesSearch.subManagerName,
            accountId: savedAssetTransferListData.assetTransferActivitiesSearch.accountId,
            accountNameShort: savedAssetTransferListData.assetTransferActivitiesSearch.accountName,
            status: savedAssetTransferListData.assetTransferActivitiesSearch.status,
            startDate: (savedAssetTransferListData.assetTransferActivitiesSearch.startDate ? savedAssetTransferListData.assetTransferActivitiesSearch.startDate.toString() : ""),
            endDate: (savedAssetTransferListData.assetTransferActivitiesSearch.endDate ? savedAssetTransferListData.assetTransferActivitiesSearch.endDate.toString() : "")
        }

        const onSuccessResponse = (response) => {

            if (!response.data || response.data.length === 0) {
                alert('No AssetTransfer activities found matching your saved assetTransfers list');
            } else {
                let assetTransferCaptureDisplayActivities = JSON.parse(JSON.stringify(assetTransferCaptureDisplayState));
                assetTransferCaptureDisplayActivities.assetTransferActivitiesSearch = buildAssetTransferActivitiesSearch(
                    searchCriteria.managerId,
                    searchCriteria.managerNameShort,
                    searchCriteria.subManagerId,
                    searchCriteria.subManagerNameShort,
                    searchCriteria.accountId,
                    savedAssetTransferListData.accountCode,
                    searchCriteria.accountNameShort,
                    searchCriteria.status,
                    searchCriteria.startDate,
                    searchCriteria.endDate,
                    response.data
                );

                assetTransferCaptureDisplayActivities.isSavedAssetTransferList = true;
                assetTransferCaptureDisplayActivities.savedName = searchCriteria.savedName;
                assetTransferCaptureDisplayActivities.savedNameListId = savedAssetTransferListData.savedNameListId;
                assetTransferCaptureDisplayActivities.currentPage = ASSET_TRANSFER_CAPTURE_PANEL_ACTIVITIES_PAGE;
                setAssetTransferCaptureDisplayState(assetTransferCaptureDisplayActivities);
            }
        }

        const onErrorResponse = (err) => {
            console.error("Error", err);
            error("Error occurred with load assetTransfer activities for saved assetTransfers list");
        }

        makePostRequest(searchCriteria,
            URL.ASSET_TRANSFER_SEARCH_URL, onSuccessResponse, onErrorResponse);
    };


    const loadAssetTransferActivitiesCanceledTrade = () => {
        const searchCriteria = {
            managerId: entityAccountsNoSwap.managerId,
            subManagerId: entityAccountsNoSwap.subManagerId,
            accountId: entityAccountsNoSwap.accountId,
            status: assetTransferPanelFilterState.status,
            startDate: dateToString(assetTransferPanelFilterState.startDate),
            endDate: dateToString(assetTransferPanelFilterState.endDate)
        }

        setShowFilter(!showFilter)

        const onSuccessResponse = (response) => {

            let assetTransferCaptureDisplayStateShowActivities = {...assetTransferCaptureDisplayState};
            assetTransferCaptureDisplayStateShowActivities.assetTransferActivitiesSearch.startDate = searchCriteria.startDate;
            assetTransferCaptureDisplayStateShowActivities.assetTransferActivitiesSearch.endDate = searchCriteria.endDate;
            assetTransferCaptureDisplayStateShowActivities.assetTransferActivitiesSearch.managerId = searchCriteria.managerId;
            assetTransferCaptureDisplayStateShowActivities.assetTransferActivitiesSearch.subManagerId = searchCriteria.subManagerId;
            assetTransferCaptureDisplayStateShowActivities.assetTransferActivitiesSearch.accountId = searchCriteria.accountId;
            assetTransferCaptureDisplayStateShowActivities.assetTransferActivitiesSearch.managerName = entityAccountsNoSwap.managerName;
            assetTransferCaptureDisplayStateShowActivities.assetTransferActivitiesSearch.subManagerName = entityAccountsNoSwap.subManagerNameShort;
            assetTransferCaptureDisplayStateShowActivities.assetTransferActivitiesSearch.accountName = entityAccountsNoSwap.accountName;
            assetTransferCaptureDisplayStateShowActivities.assetTransferActivitiesSearch.accountCode = entityAccountsNoSwap.accountCode;
            assetTransferCaptureDisplayStateShowActivities.assetTransferActivitiesSearch.badgeInfo = paramBadgeInfo(true);

            if (!response.data || response.data.length === 0) {
                assetTransferCaptureDisplayStateShowActivities.assetTransferActivitiesSearch.resData = [];
                alert('No Asset Transfer activities found matching your search');
            } else {
                assetTransferCaptureDisplayStateShowActivities.assetTransferActivitiesSearch.resData = response.data;
            }
            setShowGridToolbar(response.data && response.data.length > 0)
            assetTransferCaptureDisplayStateShowActivities.isSavedTradeList = false;
            assetTransferCaptureDisplayStateShowActivities.currentPage = ASSET_TRANSFER_CAPTURE_PANEL_ACTIVITIES_PAGE;
            setAssetTransferCaptureDisplayState(assetTransferCaptureDisplayStateShowActivities);

        }

        const onErrorResponse = (err) => {
            let errorMsg = getAllErrorValuesAsString(err.response.data)
            console.error("Error occurred with searching assetTransfer activities", errorMsg);
            error("Error occurred with searching assetTransfer activities");
        }

        makePostRequest(searchCriteria,
            URL.ASSET_TRANSFER_SEARCH_URL, onSuccessResponse, onErrorResponse);

    }

    const cancelAssetTransferSearch = (userSelectedRows, onSuccess, onError) => {

        const params = userSelectedRows.map((row) => {
            return {
                "requestId": row.requestId,
                "manager": row.manager,
                "cdAccount": row.custRefNum
            }
        })

        const onSuccessResponse = () => {
            if (onSuccess) onSuccess();
            success("Asset Transfer was cancelled successfully");

            setHeaderCheckedboxChecked(false);
            setSelectedAnyCheckbox(false)
            setSelectedRows([]);

            if (assetTransferCaptureDisplayState.isSavedTradeList) {
                loadAssetTransferActivitiesForSavedList(assetTransferCaptureDisplayState)
            }
            else {
                loadAssetTransferActivitiesCanceledTrade();
            }
        }

        const onErrorResponse = (err) => {
            console.error(err);
            if (onError) onError(err);
            error('Error on cancelling Asset Transfer(s)');
        }
        makePostRequest(params, URL.ASSET_TRANSFER_CANCEL_URL, onSuccessResponse, onErrorResponse);

    }

    const exportQueryList = (type, rowData) => {
        //Set Column definition
        const assetTransfersActsColumnsDef = columnDefsActivitiesPanel.filter(cols => cols.field !== 'checkbox' && cols.field !== 'View')
        hiddenExportGridApi.current.api.setColumnDefs(assetTransfersActsColumnsDef);
        //Set Data
        hiddenExportGridApi.current.api.setRowData(rowData || assetTransferCaptureDisplayState.assetTransferActivitiesSearch.resData);
        let filteredColumnNames = getFilteredColumns(assetTransferActivitiesGrid);
        //Export as csv/excel
        type === 'EXCEL' ?
            hiddenExportGridApi.current.api.exportDataAsExcel(createExcelExportParams('AssetTransfers', filteredColumnNames)) :
            hiddenExportGridApi.current.api.exportDataAsCsv({columnKeys: filteredColumnNames});
    }

    const setupActionColumns = () => {
        let updatedColumnDefs = [...columnDefsActivitiesPanel];
        updatedColumnDefs = addPropertiesToGridColumns(updatedColumnDefs, GRID_COLUMN_PROPERTY)
        //const updateColumnDefs = updateColumnHideState(updatedColumnDefs, columnState)
        let finalColumnDef = [...updatedColumnDefs, {headerName: 'requestId', field: 'requestId', hide: true, suppressColumnsToolPanel: true},
            {headerName: 'requestType', field: 'requestType', hide: true, suppressColumnsToolPanel: true}]
        setColumnDefs(finalColumnDef)
        //setColumnDefs(updatedColumnDefs);
    }

    useEffect( () =>{
        if(amendClicked){
            if (assetTransferCaptureDisplayState.isSavedTradeList) {
                loadAssetTransferActivitiesForSavedList(assetTransferCaptureDisplayState)
            }
            else {
                loadAssetTransferActivitiesCanceledTrade();
            }
        }
    }, [amendClicked])


    useEffect(() => {
        setupActionColumns();
        const rowData = assetTransferCaptureDisplayState.assetTransferActivitiesSearch.resData
        setRowData(rowData);
        setHandleSaveFunction({handleSave: saveAssetTransferSearch, gridApi: null});
        setHandleRenameFunction({handleRename: updateAssetTransferSearch, gridApi: gridApi});
        setHandleDeleteFunction({handleDelete: deleteAssetTransferSearch, gridApi: gridApi});
        setHandleExportFunction({handleExport: exportQueryList, gridApi: gridApi});
        setHandleCancelAssetTransferFunction({handleAssetTransferCancel: cancelAssetTransferSearch, gridApi: gridApi})
    }, [assetTransferCaptureDisplayState, columnState])

    const defaultColDef = {
        sortable: true,
        resizable: true,
        floatingFilter: true,
        filter: true,
        enableCellChangeFlash: true,
        lockPinned: !!isMobile,
    };

    const onGridReady = (params) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
    }

    const onViewClicked = (props) => {
        // set entity, account
        const correspondingEntity = getMemoizedEntityAccountsNoSwap.find((entity) => entity.managerId === props.managerId);
        const accountFound = correspondingEntity?.accounts.find((account) => account.accountCode === props.custRefNum);
        setManagerAndAccountDetails(props.managerId, props.manager, accountFound?.accountId, accountFound?.nameShort +"-" + accountFound?.nameLong,  props.custRefNum,true,true);
        
        //
        const newTradeState = JSON.parse(JSON.stringify(assetTransferCaptureDisplayState));
        newTradeState.assetTransferEntry.accountId	=	props.accountId
        newTradeState.assetTransferEntry.additionalInfo	=	props.additionalInfo
        newTradeState.assetTransferEntry.comment	=	props.comments
        newTradeState.assetTransferEntry.custRefNum	=	props.custRefNum
        newTradeState.assetTransferEntry.dtcAcctNumber	=	props.dtcAcctNumber
        newTradeState.assetTransferEntry.dtcNumber	=	props.dtcNumber
        newTradeState.assetTransferEntry.fedInstruction	=	props.fedInstruction
        newTradeState.assetTransferEntry.instructionType	=	props.instructionType
        if (props.accountType) {
            if (props.accountType === "Long") {
                newTradeState.assetTransferEntry.accountType	=	"2"       
            } else if (props.accountType === "Short") {
                newTradeState.assetTransferEntry.accountType	=	"5"       
            } else if (props.accountType === "Cash") {
                newTradeState.assetTransferEntry.accountType	=	"1"       
            }
        }
        newTradeState.assetTransferEntry.manager	=	props.manager
        newTradeState.assetTransferEntry.settleQuantity	=	props.settleQuantity
        newTradeState.assetTransferEntry.requestId	=	props.requestId
        newTradeState.assetTransferEntry.id	=	props.id
        newTradeState.assetTransferEntry.requestType	=	props.requestType
        newTradeState.assetTransferEntry.srcSecCd	=	props.srcSecCd
        newTradeState.assetTransferEntry.settleAmount	=	props.settleAmount
        newTradeState.assetTransferEntry.settleCurrency	=	props.settleCurrency
        newTradeState.assetTransferEntry.settleDate	=	props.settleDate ? yearMonthDayToPickerDateFormat(props.settleDate.toString()) : ''
        newTradeState.assetTransferEntry.settleLocation	=	props.settleLocation
        newTradeState.assetTransferEntry.status	=	props.status
        newTradeState.assetTransferEntry.uiStatus	=	props.uiStatus
        newTradeState.assetTransferEntry.tradeDate	=	props.tradeDate ? yearMonthDayToPickerDateFormat(props.tradeDate.toString()) : ''
        newTradeState.assetTransferEntry.category	=	props.category
        newTradeState.assetTransferEntry.brokerMpidId	=	props.brokerMpidId
        newTradeState.assetTransferEntry.cptyAccountNumber	=	props.cptyAccountNumber
		newTradeState.assetTransferEntry.from = 'LIST'
		
        setAssetTransferCaptureDisplayState(newTradeState)

        setViewClicked(true)
    }

    const viewCellRenderer = function (props) {
        return (<>
            {
                <a className="td-link" href="#" onClick={() => {
                    onViewClicked(props.data);
                    navigateToPage(Routes.ASSET_TRANSFER_ENTRY)
                }}>View</a>
            }
        </>);
    }

    function pageTitle() {
        return (<>
            Asset Transfer Activities
        </>)
    }

    const onDisplayedColumnsChanged = () => {
        if (gridColumnApi) {
            const updatedColumnDefs = updateGridColumDefs(gridColumnApi, columnDefs)
            setColumnDefs(updatedColumnDefs)
        }
    }

    const onDataRendered = (params) => {
        setGridApi(params.api);
        params.columnApi.autoSizeAllColumns();
        setShowButton(getDisplayedNumberOfGridRows(gridApi) >= ENABLE_SCROLL_BUTTONS_PAGINATION_SIZE)
    }

    const handleClearButtonClick = () => {
        setHeaderCheckedboxChecked(false);
        setSelectedAnyCheckbox(false)
        if (gridApi) {
            gridApi.deselectAll();
        }
    }

    const handleAssetTransferCancel = () => {
        const selected = getSelectedRows(gridApi);
        setSelectedRows(selected);
    }


    const isRowSelectable = useCallback((params) => {
        return (!!params.data) && (params.data.uiStatus === 'SUBMITTED' || params.data.uiStatus === 'ERROR' || params.data.uiStatus === 'ERROR - TD TO AMEND') && !AuthenticationService.isInternalUser();
    }, []);

    const onSelectionChanged = useCallback((params) => {
        const userSelectedRows = params.api.getSelectedRows();
        setHeaderCheckedboxChecked(userSelectedRows.length > 0)
        setSelectedAnyCheckbox(userSelectedRows.length > 0)
    }, [])

    useEffect(() => {
        if (gridApi) {
            gridApi.deselectAll();
        }
        setHeaderCheckedboxChecked(false);
        setSelectedAnyCheckbox(false);
    }, [pathname.key])

    useEffect(() => {
        if (columnState?.columnState &&
            Array.isArray(columnState?.columnState) &&
            columnState?.columnState?.length > 0) {
            const updatedColumnDefs = updateColumnHideState(columnDefsActivitiesPanel, columnState);
            setColumnDefs(updatedColumnDefs)
        }
    }, [columnState]);

    const onPaginationChange = (params) => {
        setShowButton(getDisplayedNumberOfGridRows(gridApi) >= ENABLE_SCROLL_BUTTONS_PAGINATION_SIZE);
    }

    return (<>
        <Container fluid>
            <PageHeader text={pageTitle()}>
                <AssetTransferSearchParamBadge/>
            </PageHeader>

            {showGridToolbar &&
                <AgGridToolbar title={assetTransferCaptureDisplayState.savedName} assetTransferScreen={true} gridApi={gridApi}
                               gridColumnApi={gridColumnApi}
                               columnDefs={columnDefs} setColumnDefs={setColumnDefs}
                               isSaved={assetTransferCaptureDisplayState.isSavedTradeList}
                               headerCheckboxChecked={headerCheckboxChecked}
                               setHeaderCheckedboxChecked={setHeaderCheckedboxChecked}
                               onClearButtonClick={handleClearButtonClick}
                               handleAssetTransferCancel={handleAssetTransferCancel} selectedRows={selectedRows}
                               selectedAnyCheckbox={selectedAnyCheckbox}
                               paginationPageSize={paginationPageSize} setPaginationPageSize={setPaginationPageSize}
                               showButton={showButton} setShowButton={setShowButton}
                               columnState={columnState}></AgGridToolbar>}
            <div
                ref={myGrid}
                id="myGrid"
                className="ag-theme-alpine ag-grid-block">
                <AgGridReact
                    pagination={true}
                    ref={assetTransferActivitiesGrid}
                    onPaginationChanged={onPaginationChange}
                    paginationPageSize={paginationPageSize}
                    frameworkComponents={{
                        actionsRenderer: ActionsRenderer,
                        viewCellRenderer: viewCellRenderer
                    }}
                    groupDefaultExpanded={'1'}
                    enableRowGroup={false}
                    suppressDragLeaveHidesColumns={true}
                    suppressMakeColumnVisibleAfterUnGroup={true}
                    suppressModelUpdateAfterUpdateTransaction={true}
                    suppressScrollOnNewData={true}
                    suppressAggFuncInHeader={true}
                    allowShowChangeAfterFilter={false}
                    rowGroupPanelShow={'never'}
                    enableSorting={true}
                    enableFilter={true}
                    onGridReady={onGridReady}
                    onRowDataChanged={onDataRendered}
                    defaultColDef={defaultColDef}
                    columnDefs={columnDefs}
                    rowData={rowData}
                    animateRows={true}
                    isRowSelectable={isRowSelectable}
                    onSelectionChanged={onSelectionChanged}
                    rowSelection={"multiple"}
                    getRowStyle={getRowStyle}
                >
                </AgGridReact>
            </div>
        </Container>
        {showButton && <ScrollButton showButton={showButton}/>}

    </>);
}

export const columnDefsActivitiesPanel = [

    {
        headerName: '',
        headerCheckboxSelection: true,
        field: "checkbox",
        minWidth: 120,
        checkboxSelection: true,
        showDisabledCheckboxes: true,
        cellClassRules: {
            "checkbox-disabled": (params) => {
                return AuthenticationService.isInternalUser() || !['SUBMITTED', 'ERROR','ERROR - TD TO AMEND'].includes(params.data.uiStatus)
            },
        }
    },
    {
        headerName: 'View',
        field: 'View',
        cellRenderer: 'viewCellRenderer'
    },
    {headerName: 'Request Id', field: 'requestId'},
    {headerName: 'Status', field: 'uiStatus'},
    {headerName: 'Customer Reference Number', field: 'custRefNum'},
    {headerName: 'Category', field: 'category'},
    {headerName: 'Long/Short/Cash', field: 'accountType'},
    {headerName: 'Instruction Type', field: 'instructionType'},
    {headerName: 'Security Id', field: 'srcSecCd'},
    {headerName: 'Manager', field: 'manager'},
    {
        headerName: 'Trade Date',
        field: 'tradeDate',
        valueGetter: (params) => stringToDate(dateToString(params.data.tradeDate))
    },
    {
        headerName: 'Settlement Date',
        field: 'settleDate',
        valueGetter: (params) => stringToDate(dateToString(params.data.settleDate))
    },
    {headerName: 'Settlement Location', field: 'settleLocation'},
    {headerName: 'Settlement Currency', field: 'settleCurrency'},
    {
        headerName: 'Settlement Quantity',
        field: 'settleQuantity',
        valueFormatter: numberFormatter
    },
    {
        headerName: 'Settlement Amount',
        field: 'settleAmount',
        valueFormatter: numberFormat3FractionalDigits,
        cellStyle: cellAlignment
    },
    {headerName: 'DTC Number', field: 'dtcNumber'},
    {headerName: 'DTC Account Number', field: 'dtcAcctNumber'},
    {headerName: 'Fed Delivery Instruction', field: 'fedInstruction'},
    {headerName: 'Additional Information', field: 'additionalInfo'},
    {headerName: 'comments', field: 'comments'},
    {headerName: 'Broker MPID', field: 'brokerMpidId'},
    {headerName: 'CPTY account number', field: 'cptyAccountNumber'},
    {headerName: 'status', field: 'status', hide: true, suppressColumnsToolPanel: true},
    {headerName: 'version', field: 'version', hide: true, suppressColumnsToolPanel: true},
    {headerName: 'migrated', field: 'migrated', hide: true, suppressColumnsToolPanel: true}

];